const adjustOverlayPosition = (
  overlayElement: HTMLElement,
  menuHeightCssVar = '--app-menubar-height',
) => {
  const menuHeightValue = getComputedStyle(
    document.documentElement,
  ).getPropertyValue(menuHeightCssVar);
  const menuHeight = Number.parseFloat(menuHeightValue);

  if (!Number.isFinite(menuHeight)) return;

  const currentTop = Number.parseFloat(overlayElement.style.top || '0');

  if (currentTop < menuHeight) {
    overlayElement.style.top = `${menuHeight}px`;
  }
};

export default adjustOverlayPosition;
